import { render, staticRenderFns } from "./borderConfig.vue?vue&type=template&id=0480c254&"
import script from "./borderConfig.vue?vue&type=script&lang=js&"
export * from "./borderConfig.vue?vue&type=script&lang=js&"
import style0 from "./borderConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports